import React, {
    ReactElement, useState,
} from "react";
import { GetSettingsDocument, SettingsTimeInput, useSaveSettingsMutation } from "../../../../__generated__/api";
import useDirtyTracker from "../../../../components/dirty-tracker/DirtyTracker";
import SchedulePicker from "../../../../components/office-hours/OfficeHours";
import useArticleContext from "../../../../contexts/HelpContext";
import { SettingsProps } from "../base";

export default function Time(props: SettingsProps): ReactElement {
    const [save] = useSaveSettingsMutation();
    useArticleContext("urn:fq:article:07a9a9ac677249eaa4e93efef1924f5f");

    const [settings, setSettings] = useState<SettingsTimeInput>(() => ({
        ...props.settings?.time,
        __typename: undefined,
    }));

    const dirtyTracker = useDirtyTracker({
        finishedSavingMessage: "Settings saved.",
        onSave: (event, onDone) => {
            event.preventDefault();
            (async () => {
                await save({
                    refetchQueries: [
                        { query: GetSettingsDocument },
                    ],
                    variables: {
                        time: {
                            timezone: settings?.timezone,
                            holidayCountryCode: settings?.holidayCountryCode,
                            hoursOfOperations: settings?.hoursOfOperations,
                        },
                    },
                });
                onDone();
            })();
        },
    });

    dirtyTracker.useWatchProperty(settings, props.settings?.time);

    dirtyTracker.useLoad(() => {
        if (props.settings?.time) {
            setSettings(props.settings?.time);
        }
    }, [props.settings?.time]);

    return (

        <form className="flex-grow-1">

            <SchedulePicker settings={settings} onChange={setSettings} />

            {dirtyTracker.saveComponent}

        </form>
    );
}
